import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { selectors } from '../reducer'
import * as actions from '../actions'
import { selectors as productSelectors } from '../../products/reducer'
import * as apiActions from 'api-actions'
import { Path } from 'config/portal'
import { SelectCompanyInformationForm } from '../forms'
import SharedSelectCompanyInformationView from '../../products/views/SelectCompanyInformationView'

function SelectCompanyInformationView(props) {
  return (
    <SharedSelectCompanyInformationView
      {...props}
      redirectPath={Path.ADD_NEW_TAXABLE_SERVICES_AGREEMENT}
      nextPathname="/taxable-accounts/complete-services-agreement"
      SelectCompanyInformationFormComponent={SelectCompanyInformationForm}
    />
  )
}

function mapStateToProps(state) {
  return {
    completeServicesAgreementForm:
      selectors.completeServicesAgreementForm(state),
    servicesAgreements:
      productSelectors.servicesAgreementsTaxableAccounts(state),
    erisapediaSearches: selectors.erisapediaSearches(state),
  }
}

const mapDispatchToProps = {
  fetchServicesAgreements: apiActions.fetchServicesAgreementsTaxableAccounts,
  fetchErisapediaSearches: apiActions.fetchErisapediaSearches,
  setCompleteServicesAgreementForm: actions.setCompleteServicesAgreementForm,
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  SelectCompanyInformationView
)
